module.exports = __webpack_public_path__ + "img/exemploAct.f1386445.png";